export default "__VITE_ASSET__uxW9sTZ6__"